import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter,
  Input, Output, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';

import { columns } from './../../../my-fitments/components/assign-to-products-modal/product-columns'; // todo rewrite
import { BaseModalComponent } from 'shared/modal/_base-modal.component';
import { ProductCopyOptionsComponent } from 'shared/modal/create-product-copy-modal/product-copy-options/product-copy-options.component';
import {
  CurrentProductsSearchComponent
} from 'shared/modal/create-product-copy-modal/current-products-search/current-products-search.component';
import { CreateNewProductService } from 'shared/modal/create-new-product-modal/create-new-product.service';
import { ProductCopyType } from 'shared/modal/create-product-copy-modal/product-copy-type';
import { LoaderComponent } from '../../loader/loader.component';
import { ErrorModalComponent } from 'shared/modal/error-modal/error-modal.component';
import {
  PartNumberInputModalComponent
} from 'shared/modal/create-product-copy-modal/part-number-input-modal/part-number-input-modal.component';


@Component({
  moduleId: module.id,
  selector: 'create-product-copy-modal',
  templateUrl: 'create-product-copy-modal.component.html',
  styleUrls: ['create-product-copy-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateProductCopyModalComponent extends BaseModalComponent {

  @Output() assignToProducts: EventEmitter<any> = new EventEmitter();
  @Output() assignToProductLists: EventEmitter<any> = new EventEmitter();
  @Output() openProductLists: EventEmitter<any> = new EventEmitter();
  @Output() createClicked: EventEmitter<any> = new EventEmitter();

  @Input() type: ProductCopyType;
  @Input() selectedRows;

  @ViewChild(CurrentProductsSearchComponent, {static: false})
  productsSearch: CurrentProductsSearchComponent | void;

  @ViewChild(ProductCopyOptionsComponent, {static: false})
  productCopyOptions: ProductCopyOptionsComponent;

  @ViewChild(PartNumberInputModalComponent, {static: false})
  partNumberInputModal: PartNumberInputModalComponent;

  @ViewChild('copyModalLoader', {static: false}) loader: LoaderComponent | void;
  @ViewChild('errorModal', {static: false}) errorModal: ErrorModalComponent;

  isListsSearch: boolean = false;
  productResultColumns: Array<any> = columns;

  constructor(
    private ref: ChangeDetectorRef,
    private createNewProductService: CreateNewProductService,
  ) {
    super();
  }

  get disabledCreate(): boolean {
    if (!this.productCopyOptions || !this.productsSearch) { return true; }
    if (this.type === ProductCopyType.CreateCopy && this.productsSearch.selectedRows.length > 1) { return true; }
    return !this.productCopyOptions.selectedValues.length || !this.productsSearch.selectedRows.length;
  }

  get filteredSelectedIds(): Array<string> {
    return this.productCopyOptions && _.intersection(this.productCopyOptions.filteredIds, this.productCopyOptions.selectedIds) || [];
  }

  get buttonTitle(): string {
    switch (this.type) {
      case ProductCopyType.CreateCopy:
        return 'Next';
      case ProductCopyType.CopyData:
        return 'Save';
      default:
        return '';
    }
  }

  get headerTitle(): string {
    switch (this.type) {
      case ProductCopyType.CreateCopy:
        return 'Select a source product to copy';
      case ProductCopyType.CopyData:
        return 'Select a Destination Product to Copy to';
      default:
        return '';
    }
  }

  show() {
    super.show();
    _.defer(() => {
      if (this.productsSearch) {
        this.productsSearch.startSearch();
      }
      this.ref.markForCheck();
    });
  }

  hide() {
    super.hide();
    if (this.productsSearch) {
      this.productsSearch.resetData();
    }
    if (this.productCopyOptions) {
      this.productCopyOptions.resetData();
    }
    this.isListsSearch = false;
  }

  // handlers
  onCreateBtnClick() {
    if (this.disabledCreate) { return; }

    if (!this.productsSearch) { return; }

    if (this.selectedRows && this.selectedRows.length === 1 && this.type === ProductCopyType.CopyData) {
      const source = this.selectedRows[0];
      const itemId = source.itemId;

      const productIds = this.productsSearch.selectedRowsIds;
      const productCopyId = itemId;
      const dataToCopy = this.productCopyOptions.selectedValues;

      this.showLoader();

      this.createNewProductService
        .copyProductData(this.productsSearch.brandService.getBrand(), itemId, {
          productIds,
          productCopyId,
          dataToCopy,
        })
        .subscribe((res: any) => {
          this.hideLoader();
          this.createClicked.emit(res);
          this.hide();
        });
    }


    if (this.type === ProductCopyType.CreateCopy) {
      this.partNumberInputModal.show();
    }
  }

  onPartNumberCreate() {
    if (!this.productsSearch) { return; }

    const partNumber = this.partNumberInputModal.partNumbers?.value;
    const productCopyId = this.productsSearch.selectedRows[0]?.itemId;
    const dataToCopy = this.productCopyOptions.selectedValues;

    this.showLoader();

    this.createNewProductService
      .createProductCopy(this.productsSearch.brandService.getBrand(), {
        partNumber,
        productCopyId,
        dataToCopy,
      })
      .subscribe((res: any) => {
        if (!res?.success) {
          this.hideLoader();
          this.errorModal.title = 'Something went wrong';
          this.errorModal.show();
        } else {
          this.hideLoader();
          this.createClicked.emit(res);
          this.hide();
        }
      });
  }

  onProductListsOpen() {
    this.isListsSearch = true;
    if (this.productCopyOptions) {
      this.productCopyOptions.fetchLists();
    }
    this.ref.markForCheck();
  }

  onProductListsClose() {
    this.isListsSearch = false;
    this.ref.markForCheck();
  }

  public showLoader() {
    if (this.loader instanceof LoaderComponent) {
      this.loader.show();
    }
    this.ref.markForCheck();
  }

  public hideLoader() {
    if (this.loader instanceof LoaderComponent) {
      this.loader.hide();
    }
    this.ref.markForCheck();
  }
}
